import { createAction } from 'redux-act'

import { PointsTransactionsResponse } from '../types'

export const fetchPointsTransactionsStart = createAction(
  'pointsHistory / fetch points transactions start',
)
export const fetchPointsTransactionsLoadedSuccess = createAction<PointsTransactionsResponse>(
  'pointsHistory / fetch points transactions loaded success',
)
export const fetchPointsTransactionsLoadedFail = createAction<string>(
  'pointsHistory / fetch points transactions fail',
)
